import { VK } from "./define"
import { KeyZone } from "@libs/types/enum";
import { deviceZone } from "@/service/device_zone";

export const kbVKTexture: { [index: VK]: string } = {
  0x09: "Tab",
  0x0D: "Enter",
  0x13: "Pause",
  0x14: "Caps",
  0x1B: "Esc",
  0x20: "Space",
  0x21: "PgUp",
  0x22: "PgDn",
  0x23: "End",
  0x24: "Home",
  0x25: "Left",
  0x26: "Up",
  0x27: "Right",
  0x28: "Down",
  0x2C: "PrtSc",
  0x2D: "Ins",
  0x2E: "Del",
  0x30: "0",
  0x31: "1",
  0x32: "2",
  0x33: "3",
  0x34: "4",
  0x35: "5",
  0x36: "6",
  0x37: "7",
  0x38: "8",
  0x39: "9",
  0x41: "A",
  0x42: "B",
  0x43: "C",
  0x44: "D",
  0x45: "E",
  0x46: "F",
  0x47: "G",
  0x48: "H",
  0x49: "I",
  0x4A: "J",
  0x4B: "K",
  0x4C: "L",
  0x4D: "M",
  0x4E: "N",
  0x4F: "O",
  0x50: "P",
  0x51: "Q",
  0x52: "R",
  0x53: "S",
  0x54: "T",
  0x55: "U",
  0x56: "V",
  0x57: "W",
  0x58: "X",
  0x59: "Y",
  0x5A: "Z",
  0x5D: "App",
  0x5B: "L-Win",
  0x5C: "R-Win",
  0x60: "NP 0",
  0x61: "NP 1",
  0x62: "NP 2",
  0x63: "NP 3",
  0x64: "NP 4",
  0x65: "NP 5",
  0x66: "NP 6",
  0x67: "NP 7",
  0x68: "NP 8",
  0x69: "NP 9",
  0x6A: "*",
  0x6B: "+",
  0x6D: "-",
  0x6E: ".",
  0x6F: "/",
  0x70: "F1",
  0x71: "F2",
  0x72: "F3",
  0x73: "F4",
  0x74: "F5",
  0x75: "F6",
  0x76: "F7",
  0x77: "F8",
  0x78: "F9",
  0x79: "F10",
  0x7A: "F11",
  0x7B: "F12",
  0x90: "Num",
  0x91: "Scrl",
  0xA0: "L-Shift",
  0xA1: "R-Shift",
  0xA2: "L-Ctrl",
  0xA3: "R-Ctrl",
  0xA4: "L-Alt",
  0xA5: "R-Alt",
  0xBA: ";:",
  0xBB: "=+",
  0xBC: ",<",
  0xBD: "-_",
  0xBE: ".>",
  0xBF: "/?",
  0xC0: "`~",
  0xDB: "[{",
  0xDC: "\\|",
  0xDD: "]}",
  0xDE: "'",
  0xFD: "Num\nEnter",
  0xFA: "FN",
  0x08: "Back"
}
export const mouseVKs: { [index: VK]: string } = {
  0x01: "left_key",
  0x02: "right_key",
  0x04: "wheel_key",
  0x05: "forward_key",
  0x06: "back_key",
  0x98: "dpi_switch_add",
  0x99: "dpi_switch_sub",
  0x9a: "DPI_Loop_add",
  0x9b: "DPI_Loop_sub",
  0x9c: "wheel_up_scroll",
  0x9d: "wheel_down_scroll",
  0x9e: "mouse_up_move",
  0x9f: "mouse_down_move",
  0x89: "mouse_left_move",
  0x8a: "mouse_right_move",
}
export const mediaVKS: { [index: VK]: string } = {
  0xA6: 'web_page_return',
  0xA7: 'page_forward',
  0xA8: 'web_page_refresh',
  0xA9: "page_stop",
  0xAB: "web_favorite",
  0xAC: "WWW_home_page",
  0xB5: "media_player",
  0xB3: "play_pause",
  0xB1: "previous_song",
  0xB2: "stop_playing",
  0xB0: "next_song",
  0xAF: "volume_up",
  0xAE: "vol",
  0xAD: "mute",
  0xB4: "mail",
  0xB7: "calculator",
  0xB6: "resource_manager",
  0xAA: "search"
}

export const AssistKeys = (): VK[] => deviceZone.getKeysOrDefault(KeyZone.modifierKey, defaultAssistKeys);
export const SpecialKeys = (): VK[] => {
  const specialKeys = deviceZone.getKeysOrDefault(KeyZone.extendKey, defaultSpecialKeys);
  return [...specialKeys, ...AssistKeys()];
}
export const BaseKeys = (): VK[] => deviceZone.getKeysOrDefault(KeyZone.normalKey, defaultBaseKeys);
export const mouseBaseKeys = (): VK[] => deviceZone.getKeysOrDefault(KeyZone.mouse, defaultMouseBaseKeys);

export const mediaKeys = () => {
  return deviceZone.getKeysOrDefault(KeyZone.media, []);
}

export const ShortconKeys: VK[] = [
  0xA1,
  0xA3,
  0xA5,
]

const defaultSpecialKeys: VK[] = [
  96,
  97,
  98,
  99,
  100,
  101,
  102,
  103,
  104,
  105,
  112,
  113,
  114,
  115,
  116,
  117,
  118,
  119,
  120,
  121,
  122,
  123,
  27,
  9,
  20,
  8,
  13,
  32,
  38,
  40,
  37,
  39,
  36,
  35,
  33,
  34,
  45,
  46,
  44,
  145,
  19,
  144,
  111,
  106,
  109,
  107,
  110,
  253
]
const defaultBaseKeys: VK[] = [
  65,
  66,
  67,
  68,
  69,
  70,
  71,
  72,
  73,
  74,
  75,
  76,
  77,
  78,
  79,
  80,
  81,
  82,
  83,
  84,
  85,
  86,
  87,
  88,
  89,
  90,
  192,
  49,
  50,
  51,
  52,
  53,
  54,
  55,
  56,
  57,
  48,
  189,
  187,
  219,
  221,
  220,
  186,
  222,
  188,
  190,
  191
]
// 辅助键
const defaultAssistKeys: VK[] = [
  0xA0,
  0xA1,
  0xA2,
  0xA3,
  0xA4,
  0xA5,
  0x5B,
  0x5C,
]
const defaultMouseBaseKeys: VK[] = [
  0x01,
  0x02,
  0x04,
  0x05,//前进键
  0x06,//后退键
]
